// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { EscalationData } from '../Classes/EscalationData';
import { AdditionalLaborCategory } from '../Classes/AdditionalLaborCategory';
export class Escalations {
  siemensAtMaterialEscalation: EscalationData;
  siemensMaterialEscalation: EscalationData;
  outsideMaterialEscalation: EscalationData;
  mechanicalMaterialEscalation: EscalationData;
  electricalMaterialEscalation: EscalationData;
  pmLaborEscalation: EscalationData;
  elecLaborEscalation: EscalationData;
  specLaborEscalation: EscalationData;
  engLaborEscalation: EscalationData;
  nengLaborEscalation: EscalationData;
  qengLaborEscalation: EscalationData;
  cengLaborEscalation: EscalationData;
  eengLaborEscalation: EscalationData;
  lengLaborEscalation: EscalationData;
  mechLaborEscalation: EscalationData;
  progLaborEscalation: EscalationData;
  grapLaborEscalation: EscalationData;
  ddepLaborEscalation: EscalationData;
  additionalLaborCatEscalationsList: AdditionalLaborCategory;
  applyMaterialEscalationToAll: boolean;
  applyLaborEscalationToAll: boolean;
}
